module.exports = __webpack_public_path__ + "img/3diamond-06.6d442444.svg";